/**
 * Used to indicate when an array has "empty" slots. For example, this array has a gap at
 * element [1], and 2 trailing gaps:
 *
 *     {
 *       const a = new Array(5);
 *       a[0] = "foo";
 *       a[2] = "bar";
 *       return a
 *     }
 *
 * and would produce this output in our object explorer:
 *
 *     Array(5) ["foo", empty, "bar", empty × 2]
 */
import { type FC } from "react";

export type EmptySlotsProps = {
	n: number;
};

export const EmptySlots: FC<EmptySlotsProps> = ({ n }) => {
	return <span className="text-syntax-comment italic">{n === 1 ? "empty" : `empty × ${n}`}</span>;
};
